import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import root from 'window-or-global';
import PropTypes from 'prop-types';

import {Alert} from '../';
import taxActions from '../../actions/tax.actions';
import {getMessage} from '../common/Message';
import styles from '../header/Header.pcss';

const mapDispatchToProps = {
    fetchBalancePayable: taxActions.getBalancePayable
};

const mapStateToProps = state => ({
    messages: state.get('localization').get('messageProperties'),
    taxState: state.get('tax').toJS()
});

const ON_DISPLAY = "ON_DISPLAY";

const AlertBar = ({fetchBalancePayable, taxState, messages, ...props}) => {
    const [open, setOpen] = useState(false);
    useEffect(() => {
        fetchBalancePayable();
    }, []);
    useEffect(() => {
        setOpen(taxState.payAble);
    }, [taxState.payAble]);
    const message = getMessage(messages, 'epic.affiliate.settings.tax.profile.payable', [
        'settings'
    ]);
    const showing = root.sessionStorage && root.sessionStorage.getItem(ON_DISPLAY);
    if (showing) {
        return null;
    }
    return (
        <Alert
            customClassNames={styles.globalAlert}
            type="Danger"
            message={message}
            show={open && !taxState.taxInterviewUrl}
            closeAlert={() => {
                root.sessionStorage.setItem(ON_DISPLAY, "show");
                setOpen(false);
            }}
            html
        />
    );
};

AlertBar.propTypes = {
    fetchBalancePayable: PropTypes.func,
    messages: PropTypes.object,
    taxState: PropTypes.object
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AlertBar);
